module.exports = __webpack_public_path__ + "img/nav_icon_invest_blue.82accd60.svg";